import React, { useEffect, useState } from "react";

const WEDDING_DATE = new Date("2027-02-20T20:30:00Z"); // Feb 20, 2027, 3:30 p.m. EST

function diff() {
  const t = WEDDING_DATE.getTime() - Date.now();
  const d = Math.max(0, t);
  return {
    days: Math.floor(d / 86400000),
    hours: Math.floor((d % 86400000) / 3600000),
    minutes: Math.floor((d % 3600000) / 60000),
    seconds: Math.floor((d % 60000) / 1000),
  };
}

export function Countdown({ light = false }) {
  const [c, setC] = useState(diff());
  useEffect(() => {
    const i = setInterval(() => setC(diff()), 1000);
    return () => clearInterval(i);
  }, []);
  const units = [["Days", c.days], ["Hours", c.hours], ["Minutes", c.minutes], ["Seconds", c.seconds]];
  return (
    <div className="flex gap-5 sm:gap-10" data-testid="countdown">
      {units.map(([label, val]) => (
        <div key={label} className="text-center">
          <div className={`font-serif text-4xl sm:text-6xl leading-none ${light ? "text-soft-white" : "text-matte"}`}>
            {String(val).padStart(2, "0")}
          </div>
          <div className={`overline mt-2 ${light ? "text-soft-white/70" : "text-taupe"}`}>{label}</div>
        </div>
      ))}
    </div>
  );
}
